import { useTranslation } from 'react-i18next'

function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="tc-footer-style6">
      <div className="container">
        <div className="content">
          <div className="foot-links"></div>
          <div className="main-content">
            <div className="row justify-content-between">
              <div className="col-lg-3">
                <div className="social-links text-center text-lg-start">
                  <h4 className="foot-title fsz-24 text-uppercase mb-30 mt-70">
                    {t('footer.social')}
                  </h4>
                  <div className="links">
                    <a href="#/">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://www.instagram.com/bijouterie.r.j/">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="https://www.tiktok.com/@bijouterie.r.j">
                      <i className="fab fa-tiktok"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="foot-info text-center">
                  <h4 className="foot-title fsz-24 text-uppercase mb-30 mt-70">
                    {t('footer.information')}
                  </h4>
                  <ul className="color-666">
                    <li>
                      <a href="#/"> (514) 291-2623 </a>
                    </li>
                    <li>
                      <a href="#/"> bijouterierj@gmail.com </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="newsletter text-center text-lg-end">
                  <h4 className="foot-title fsz-24 text-uppercase mb-30 mt-70">
                    {t('footer.newsletter')}
                  </h4>
                  <div className="form-group">
                    <span className="icon me-2">
                      <i className="fal fa-envelope"></i>
                    </span>
                    <input type="text" placeholder={t('footer.emailPlaceholder')} />
                    <button>
                      <i className="fal fa-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="payment">
            <img src="/assets/images/branding/payments/payment_s.png" alt="" />
          </div>
          <div className="copy text-center mt-50">
            <p className="color-666">{t('footer.copyright')}</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
